import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export function KvellLogo() {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "kvell-logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 320) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Img
      fadeIn
      className="image is-5by4 is-project-img"
      Tag="figure"
      imgStyle={{
        objectFit: "inherit",
      }}
      fluid={data.placeholderImage.childImageSharp.fluid}
    />
  )
}
